import { Alert, Box, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import { AppPortal } from 'svix-react';
import 'svix-react/style.css';
import { AccountService } from '../api';
import RotatingLoader from '../common/ui/RotatingLoader';

export const SvixPortalSettings = () => {
  const { t } = useTranslation();
  const [portalUrl, setPortalUrl] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPortalUrl = async () => {
      try {
        setIsLoading(true);
        setError(null);
        const url = await AccountService.getSvixAppPortal();
        setPortalUrl(url);
      } catch (err) {
        setError('Failed to load Svix App Portal');
        console.error('Error fetching Svix App Portal URL:', err);
      } finally {
        setIsLoading(false);
      }
    };

    void fetchPortalUrl();
  }, []);

  if (isLoading) {
    return (
      <Grid
        container
        sx={{
          minHeight: '400px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
        <RotatingLoader />
      </Grid>
    );
  }

  if (error) {
    return (
      <Grid container flexDirection="column" spacing={2}>
        <Grid item>
          <Typography variant="h4">{t('accountSettings.svixPortal.title')}</Typography>
        </Grid>
        <Grid item>
          <Alert severity="error">{error}</Alert>
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container flexDirection="column" spacing={2} p={2}>
      <Grid item>
        <Typography variant="h4">{t('accountSettings.svixPortal.title')}</Typography>
      </Grid>
      <Grid item>
        <Typography variant="body1" color="grey">
          {t('accountSettings.svixPortal.description')}
        </Typography>
      </Grid>
      <Grid item>
        <Box sx={{ width: '100%', height: '800px', border: '1px solid #e0e0e0', borderRadius: 1 }}>
          {portalUrl && <AppPortal url={portalUrl} />}
        </Box>
      </Grid>
    </Grid>
  );
};
